import { useTranslator } from 'tradera/lang/translate';
import { useFormatUtcDateInSwedishTimeZone } from 'tradera/hooks/use-format-utc-date-in-swedish-timezone';
import { useCountdown } from 'tradera/hooks/use-countdown';
import { formatItemCardTimeLeft } from 'tradera/utils/format-time-left';
import React from 'react';

export const EndTimeLabel = ({ time }) => {
    const { t } = useTranslator();
    const formatUtcDateInSwedishTimeZone = useFormatUtcDateInSwedishTimeZone();
    const {
        timeLeftText,
        isCountdownDone,
        isCountdownEnabled,
        isTimeLeftBelowWarningLimit
    } = useCountdown(time, formatItemCardTimeLeft);

    const timeText = timeLeftText
        ? timeLeftText
        : time
        ? formatUtcDateInSwedishTimeZone(time)
        : '';

    return (
        <>
            {isCountdownEnabled && isCountdownDone ? (
                <span className={`text-muted mr-2`}>{t('itemCard_ended')}</span>
            ) : (
                <span
                    className={`${
                        isTimeLeftBelowWarningLimit
                            ? 'text-danger'
                            : 'text-muted'
                    } mr-2`}>
                    {timeText}
                </span>
            )}
        </>
    );
};
